import * as c from '../../../../../../constants.jsx';
import NewbornPanelsCardTemplate from '../../../../../../components/CockpitCards/NewbornPanelsCardTemplate.jsx';

export default function MetabolicFattyAcidCard() {

return(
<>

<NewbornPanelsCardTemplate

  panel_url = {`${c.API_URL}/api/metabolicfattyacid`}

  panel_name = { "METABOLIC DISORDERS" }
  panel_subtext = {"FATTY ACID OXIDATION DISORDERS - This panel is based on the Recommended Uniform Screening Panel (RUSP), a list of conditions selected by experts for newborn screening programs."}

/>

</> 
)}

